import { useEffect, useRef } from 'react';

import { useGroupState, useGroupActions } from './GroupContext';

import { getGroup } from './restApi';

const GroupLoader = () => {
  const state = useGroupState();
  const { onResponse, onError } = useGroupActions();
  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (state?.group?.id && state?.loading && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      getGroup({
        id: state.group.id,
        onResponse,
        onError,
      });
    }
  }, [state?.group?.id, state?.loading, onResponse, onError]);

  useEffect(() => {
    if (!!state?.group?.name) {
      document.title = `Isibute | ${state.group.name}`;
    }
  }, [state?.group?.name]);

  return null;
};

export default GroupLoader;
